import { DOCUMENT_TYPE } from '@mos-front-components/public/es/components/Passport/private/constants';
import {
  CHANGE_MAIN_DATA_CHILD,
  CHANGE_PASSPORT_DATA,
  CHANGE_PASSPORT_DATA_CHILD,
  CHANGE_DOCUMENT_TYPE,
  CHANGE_DOCUMENT_TYPE_CHILD,
  SELECT_CHILD,
  SET_MAIN_DATA_CHILD,
  SET_PASSPORT_DATA_CHILD
} from '../constants';

import uppercasePassportNumber from '../../services/uppercasePassportNumber';
import { snilsValidate } from '../../services/validationRules';
import {
  getDocumentFromTypeSelector,
  passportValuesSelector
} from '../passport/selectors';
import {
  mainDataChildrenSelector,
  mainDataFullValuesSelector
} from '../mainData/selectors';
import {
  getDocumentFromTypeSelector as getDocumentFromTypeChildSelector,
  passportValuesSelector as passportValuesChildSelector
} from '../passportChild/selectors';
import { getUserSnilsSelector as getChildSnilsSelector } from '../mainDataChild/selectors';
import { currentExamSelector } from '../examData/selectors';
import mainDataChildSerializer from '../serializers/mainDataChildSerializer';
import passportChildSerializer from '../serializers/passportChildSerializer';
import { findAppeal } from '../appealFind/actions';
import { resetActRecordData } from '../actRecord/actions';
import { applicantTypeSelector } from '../applicant/selectors';
import { APPLICANT_TYPES } from '../../constants/applicant';

const { MILITARY_ID, OFFICER_ID } = DOCUMENT_TYPE;

export const changeMainDataMiddleware = ({
  dispatch,
  getState
}) => next => action => {
  const { type, payload } = action;

  if (type !== CHANGE_MAIN_DATA_CHILD && type !== SET_MAIN_DATA_CHILD) {
    return next(action);
  }

  const state = getState();
  const snils = getChildSnilsSelector(state);
  let hasSnilsChanged = false;

  if (SET_MAIN_DATA_CHILD) {
    hasSnilsChanged = payload.snils !== snils;
  } else if (CHANGE_MAIN_DATA_CHILD) {
    hasSnilsChanged = payload.field === 'snils' && snils !== payload.data.snils;
  }

  if (hasSnilsChanged && snils.match(snilsValidate.pattern)) {
    const { examId } = currentExamSelector(state);

    if (examId) {
      dispatch(
        findAppeal({
          snils,
          examId
        })
      );
    }
  }

  return next(action);
};

export const changePassportDataMiddleware = () => next => action => {
  const { type, payload } = action;
  if (type !== CHANGE_PASSPORT_DATA && type !== CHANGE_PASSPORT_DATA_CHILD) {
    return next(action);
  }

  const data = payload.data || payload;
  const trimData = {};

  Object.keys(data).forEach((value, index) => {
    trimData[value] = data[value].replace(/(^\s+)|(\s{2,}$)/, '');
  });

  let number = trimData.number;

  if (data.documentType === MILITARY_ID) {
    number = uppercasePassportNumber(trimData.number);
  }

  if (data.documentType === OFFICER_ID) {
    number = uppercasePassportNumber(trimData.number);
  }

  return next({
    type,
    payload: {
      ...payload,
      data: {
        ...trimData,
        number
      }
    }
  });
};

export const changeDocumentTypeMiddleware = ({
  getState,
  dispatch
}) => next => action => {
  if (
    action.type !== CHANGE_DOCUMENT_TYPE &&
    action.type !== CHANGE_DOCUMENT_TYPE_CHILD
  ) {
    return next(action);
  }

  const newDocumentType = action.payload;
  const state = getState();
  const selector =
    action.type === CHANGE_DOCUMENT_TYPE
      ? getDocumentFromTypeSelector
      : getDocumentFromTypeChildSelector;
  const payload = selector(newDocumentType)(state);

  const applicantType = applicantTypeSelector(state);
  const passportData =
    applicantType === APPLICANT_TYPES.parent
      ? passportValuesChildSelector(state)
      : passportValuesSelector(state);

  if (newDocumentType !== passportData.documentType) {
    dispatch(resetActRecordData());
  }

  return next({ type: action.type, payload: { data: payload } });
};

export const selectChildMiddleware = ({
  getState,
  dispatch
}) => next => action => {
  if (action.type !== SELECT_CHILD) {
    return next(action);
  }

  const state = getState();
  const children = mainDataChildrenSelector(state);
  const parent = mainDataFullValuesSelector(state);

  const selectedChild = children.filter(
    child => child.item_id === action.payload.value
  )[0];

  dispatch({
    type: SET_MAIN_DATA_CHILD,
    payload: mainDataChildSerializer(selectedChild, parent)
  });
  dispatch({
    type: SET_PASSPORT_DATA_CHILD,
    payload: passportChildSerializer(selectedChild)
  });
  dispatch(resetActRecordData());

  return next(action);
};

const stepPersonMiddleware = [
  changeMainDataMiddleware,
  changePassportDataMiddleware,
  changeDocumentTypeMiddleware,
  selectChildMiddleware
];

export default stepPersonMiddleware;
